import { useContext, useState } from 'react';
import { View } from '@shared/components/View';
import { MBButton } from '@shared/components/button';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { QRCode } from './QRCode';

interface Props {
  url: string;
  onCopyQr(data: string): void;
  onCopyLink(uri: string): void;
}

export function ShareQRCodeSection({ url, onCopyLink }: Props) {
  const colors = useContext(ColorThemeContext);
  const [showSuccessButton, setShowSuccessButton] = useState(false);

  const copyLinkClicked = () => {
    onCopyLink(url);
    setShowSuccessButton(true);
    global.setTimeout(() => {
      setShowSuccessButton(false);
    }, 1000);
  };

  return (
    <View paddingHorizontal={2}>
      <View paddingBottom={1} paddingHorizontal={2} center>
        <QRCode size={{ width: 160 }} url={url} />
      </View>
      <View paddingHorizontal={2} paddingVertical={1}>
        {showSuccessButton && (
          <MBButton
            style={{ backgroundColor: colors.highlightActive }}
            paddingHorizontal={2}
            title={i18n('qrCode.share.linkCopied')}
            titleColor={colors.foregroundActive}
            leftIcon={'check-filled'}
            leftIconSize={30}
            theme="normal"
            onPress={() => {}}
            leftIconColor={colors.accent}
          />
        )}
        {!showSuccessButton && (
          <MBButton
            paddingHorizontal={2}
            title={i18n('qrCode.share.copyLink')}
            onPress={copyLinkClicked}
            theme="tertiary"
            leftIcon={'link'}
            leftIconSize={30}
          />
        )}
      </View>
    </View>
  );
}
